import React, { useEffect, memo } from "react";
import Modal from "./Modal";
import "./styles/scss/ActShadow.scss";

function App(props) {
	const { isShow, onClose } = props;

	useEffect(() => {
		if (isShow) {
			if (window.mbQuery) {
				window.mbQuery?.setActShadowIsShow?.(true);
			} else {
				window.localStorage.setItem("actShadowIsShow", true);
			}
		}
	}, [isShow]);

	return (
		<Modal className="popup-act-shadow" visible={isShow} onClose={onClose}>
			<div
				onClick={() => {
					onClose();
					props.onOk?.();
				}}
			></div>
		</Modal>
	);
}

export default memo(App);
